import {Directive, TemplateRef} from '@angular/core';

@Directive({
    selector: '[editMode]',
    standalone: false
})
export class EditModeDirective {
  constructor(public tpl: TemplateRef<any>) {
  }
}
